import { useMemo } from 'react';
import { useFavorites } from './useFavorites';

export const useFavoriteIds = () => {
    const favoritesData = useFavorites();
    
    return useMemo(() => new Set(favoritesData.map(fav => fav.id)), [favoritesData]);
}